// NOTE: Please add all new colors under the "primary" or "preset" key in the colors object
// "primary" is for colors that are used in the primary theme of the site
// "preset" is for colors that are configurable within Sanity
// "border" and "system" are 2026 brand groups for borders and system states.
// Deprecated (kept for string-resolution safety, not for new use):
// - primary.black
// - grey.darker
// - preset.rainbow

// TODO: Move all colors to the away from "brand" and into "primary" or "preset" whenever possible.
export const colors = {
  primary: {
    midGrey: "#5B5B5D",
    white: "#FFFFFF",
    softGrey: "#F7F7F7",
    black: "#000000",
    corePink: "#FFEEF2",
    whiteOverlay: "rgba(255, 255, 255, 0.88)",
    warmPink: "#FFF6F8",
    saleRed: "#FF0005",
    babyPink: "#FFEFF3",
  },
  secondary: {
    darkGrey: "#5B5B5D",
    grey: "#A4A5AA",
    success: "#14AE5C",
    midPink: "#FFDEE6",
    darkPink: "#FFC8D5",
  },
  border: {
    lightest: "#F2F2F2",
    lighter: "#E9E9EA",
    light: "#D2D2D4",
    mid: "#B9BABC",
    dark: "#A4A5AA",
    faint: "rgba(0, 0, 0, 0.1)",
    faintGrey: "rgba(113, 113, 130, 0.3)",
  },
  system: {
    success: "#14AE5C",
    warning: "#F2BD34",
    error: "#EA0F14",
    focus: "#007BFF", // 2026 input focus ring
  },
  grey: {
    lightest: "#FAFAFA",
    lighter: "#E9E9EA",
    light: "#D2D2D4",
    dark: "#A4A5AA",
    darker: "#A4A5AA",
    overlay: "rgba(67, 66, 62, 0.6)",
    darkerOverlay: "#00000033",
  },
  text: {
    primary: "#5B5B5D",
    secondary: "#74767A",
    white: "#FFFFFF",
    placeholder: "#878789",
    disabled: "#A4A5AA",
    error: "#EA0F14",
    sale: "#FF0005",
  },
  preset: {
    red: "#FF3B1F",
    redAccent: "#FFD8DA",
    pink: "#FF8FDE",
    pinkAccent: "#FFE4F3",
    fairyFloss: "#FFB4E9",
    green: "#C6F990",
    greenAccent: "#EAFBCF",
    teal: "#19D3C5",
    tealAccent: "#E8FDFE",
    blue: "#7DC2FF",
    blueAccent: "#EBF4FB",
    purple: "#CFAAF7",
    purpleAccent: "#F6EFFF",
    orange: "#FFAE61",
    orangeAccent: "#FFF7EF",
    rainbow: "linear-gradient(113deg, #FF3B1F 1.28%, #FF8FDE 21.02%, #C6F990 40.77%, #19D3C5 60.51%, #7DC2FF 80.26%, #CFAAF7 100%)",
  },
}
